import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Container,
    Button,
    Flex,
    Text,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Seo from '@salesforce/retail-react-app/app/components/seo'
import {MRT_API_BASEPATH} from '../../ssr/constants'
import {useOrigin} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'

const TestOMSReturnOrder = () => {
    const [message, setMessage] = useState('')
    const appOrigin = useOrigin(false)

    // Handle the return order action
    const handleReturnOrder = async () => {
        try {
            // Example return order payload
            // TODO - Update the OrderSummary ID and other fields as needed
            const returnOrderPayload = {
                inputs: [
                    {
                        ReturnInputDescriptor: {
                            orderSummaryId: '{{ReturnOrderSummaryId}}', // dynamic OrderSummary ID here from OMS
                            labelFlag: 'Y', // Possible values: Y: label & tracking number requested. N: no tracking number/label requested
                            shipFromCity: 'Rome',
                            shipFromStreet: 'Via Positano',
                            shipFromCountryCode: 'IT',
                            shipFromStateCode: 'RM',
                            shippingStreetNumber: '30',
                            returnItems: [
                                {
                                    orderItemSummaryId: '{{ReturnOrderItemSummaryId}}', // dynamic OrderItemSummary ID here from OMS
                                    quantity: '1',
                                    reasonForReturn: '01', // Reason for return (01 to 09)
                                },
                            ],
                        },
                    },
                ],
            }

            // Call the return-order-oms API
            const response = await fetch(`${appOrigin}${MRT_API_BASEPATH}/return-order-oms`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(returnOrderPayload),
            })

            const result = await response.json()
            if (result.success) {
                setMessage('Return order created successfully')
            } else {
                setMessage('Failed to create return order: ' + result.error)
            }
        } catch (error) {
            console.error('Error during return order creation:', error)
            setMessage('Error during return order creation: ' + error.message)
        }
    }

    return (
        <Box data-testid="test-return-order-page" bg="gray.50" py={[8, 16]}>
            <Seo title="Test Return Order" description="Test return order" />
            <Container
                paddingTop={16}
                width="auto"
                bg="white"
                paddingBottom={14}
                marginTop={8}
                marginBottom={8}
                borderRadius="base"
            >
                {message && (
                    <Flex justify="center" mb={4}>
                        <Text color="red.500" fontWeight="bold">
                            {message}
                        </Text>
                    </Flex>
                )}

                <Flex justify="center">
                    <Button variant="primary" colorScheme="blue" onClick={handleReturnOrder}>
                        Return Order - Test OMS Auth token & return order API
                    </Button>
                </Flex>
            </Container>
        </Box>
    )
}

TestOMSReturnOrder.getTemplateName = () => 'test-return-order'

TestOMSReturnOrder.propTypes = {
    match: PropTypes.object,
}

export default TestOMSReturnOrder
